<div class="px-2 sm:px-4 md:px-8 py-6">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
      N58 Banco Digital
    </h1>
    <div class="flex items-center gap-2 flex-wrap">
      <span *ngIf="!healthLoading" class="px-3 py-1 rounded-full text-xs font-bold inline-flex items-center gap-1.5"
        [style.background]="health?.operational ? '#f0fdf4' : '#fef2f2'"
        [style.color]="health?.operational ? '#15803d' : '#b91c1c'"
        [style.border]="health?.operational ? '1px solid #bbf7d0' : '1px solid #fecaca'">
        <span class="health-dot" [class.dot-ok]="health?.operational" [class.dot-down]="!health?.operational"></span>
        {{ health?.operational ? 'Operacional' : 'No operacional' }}
      </span>
      <mat-spinner *ngIf="healthLoading" diameter="20"></mat-spinner>
      <span class="px-2 py-1 rounded-full text-xs font-semibold inline-flex items-center gap-1.5"
        [style.background]="socketConnected ? '#f0f9ff' : '#f3f4f6'"
        [style.color]="socketConnected ? '#0369a1' : '#9ca3af'"
        [style.border]="socketConnected ? '1px solid #bae6fd' : '1px solid #e5e7eb'">
        <span class="health-dot" [class.dot-live]="socketConnected"></span>
        {{ socketConnected ? 'Live' : 'Offline' }}
      </span>

      <!--
        Casos abiertos. Va primero y en rojo cuando hay: el problema que
        resuelve es que se olviden, asi que tiene que verse antes que el resto.
        Cuando no hay casos queda apagado y no grita.
      -->
      <button type="button" (click)="openCasosModal()" *ngIf="!casosCargando"
        [title]="casosAbiertos > 0 ? 'Pagos que esperan una decision' : 'No hay casos abiertos'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        [style.background]="casosAbiertos > 0 ? '#b91c1c' : 'white'"
        [style.color]="casosAbiertos > 0 ? 'white' : '#6b7280'"
        [style.border]="casosAbiertos > 0 ? 'none' : '1px solid #d1d5db'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;"
          [style.color]="casosAbiertos > 0 ? 'white' : '#6b7280'">
          {{ casosAbiertos > 0 ? 'report_problem' : 'check_circle' }}
        </mat-icon>
        {{ casosAbiertos > 0 ? 'Casos abiertos (' + casosAbiertos + ')' : 'Sin casos abiertos' }}
      </button>

      <button type="button" (click)="openRegistrarOperadorModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">post_add</mat-icon>
        Registrar referencia
      </button>

      <button type="button" (click)="openMontoMinModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #1C593D; border: 1px solid #1C593D; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">tune</mat-icon>
        Monto mínimo
      </button>
    </div>
  </div>

  <!-- Health detail -->
  <div class="grid grid-cols-3 gap-3 mb-5" *ngIf="health && !healthLoading">
    <div class="bg-white rounded-xl border border-gray-100 shadow-sm p-3">
      <span style="font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">SSL</span>
      <div class="flex items-center gap-1.5 mt-1" [ngClass]="sslDaysClass">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">{{ health.ssl.valid ? 'lock' : 'lock_open' }}</mat-icon>
        <span class="text-sm font-bold">{{ health.ssl.daysRemaining !== null ? health.ssl.daysRemaining + 'd' : '--' }}</span>
      </div>
    </div>
    <div class="bg-white rounded-xl border border-gray-100 shadow-sm p-3">
      <span style="font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Sesión</span>
      <div class="flex items-center gap-1.5 mt-1" [style.color]="health.session.active ? '#15803d' : '#dc2626'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">{{ health.session.active ? 'check_circle' : 'cancel' }}</mat-icon>
        <span class="text-sm font-bold">{{ health.session.active ? 'Activa' : 'Inactiva' }}</span>
      </div>
    </div>
    <div class="bg-white rounded-xl border border-gray-100 shadow-sm p-3">
      <span style="font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Config</span>
      <div class="flex items-center gap-1.5 mt-1" [style.color]="health.config.loaded ? '#15803d' : '#dc2626'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">{{ health.config.loaded ? 'settings' : 'error' }}</mat-icon>
        <span class="text-sm font-bold">{{ health.config.loaded ? 'Cargada' : 'Error' }}</span>
      </div>
    </div>
  </div>

  <!-- Cuentas / Saldos -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5" *ngIf="!accountsLoading && accounts.length > 0">
    <div *ngFor="let acc of accounts" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 18px; border-bottom: 2px solid #bbf7d0;" class="flex items-center gap-2">
        <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">account_balance</mat-icon>
        <span style="font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #374151;">{{ acc.account_detail?.account_n58_type || 'Cuenta' }}</span>
        <span class="ml-auto px-2 py-0.5 text-xs font-bold rounded-full"
          [style.background]="acc.account_status === 'active' ? '#16a34a' : '#6b7280'"
          style="color: white;">
          {{ acc.account_status === 'active' ? 'Activa' : acc.account_status }}
        </span>
      </div>
      <div class="p-4">
        <div style="font-size: 0.85rem; font-weight: 600; color: #374151; letter-spacing: 0.5px; font-family: monospace;">{{ acc.account_detail?.account_number }}</div>
        <div style="font-size: 0.7rem; color: #9ca3af; margin-bottom: 12px;">{{ acc.account_detail?.account_currency || 'VES' }}</div>
        <div style="border-top: 1px solid #e5e7eb; padding-top: 12px;">
          <div style="font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Saldo disponible</div>
          <div style="font-size: 1.6rem; font-weight: 800; color: #1e5a3f;">{{ parseN58Amount(acc.account_balance) | number:'1.2-2' }}</div>
        </div>
        <div class="grid grid-cols-3 gap-3 mt-3">
          <div style="background: #f0fdf4; border-radius: 10px; padding: 8px; text-align: center;">
            <span style="font-size: 0.62rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Total</span>
            <span style="font-size: 0.82rem; font-weight: 700; color: #1e5a3f;">{{ parseN58Amount(acc.account_detail?.account_total_balance) | number:'1.2-2' }}</span>
          </div>
          <div style="background: #fef2f2; border-radius: 10px; padding: 8px; text-align: center;">
            <span style="font-size: 0.62rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Bloqueado</span>
            <span style="font-size: 0.82rem; font-weight: 700; color: #dc2626;">{{ parseN58Amount(acc.account_detail?.account_blocked_balance) | number:'1.2-2' }}</span>
          </div>
          <div style="background: #f3f4f6; border-radius: 10px; padding: 8px; text-align: center;">
            <span style="font-size: 0.62rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Diferido</span>
            <span style="font-size: 0.82rem; font-weight: 700; color: #374151;">{{ parseN58Amount(acc.account_detail?.account_deferred_balance) | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="accountsLoading" class="flex justify-center py-4 mb-5">
    <mat-spinner diameter="24"></mat-spinner>
  </div>

  <!-- Error banner -->
  <div *ngIf="healthError" style="display: flex; align-items: center; gap: 8px; background: #fef2f2; padding: 12px 16px; border-radius: 10px; border: 1px solid #fecaca; margin-bottom: 20px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">warning</mat-icon>
    <span style="font-size: 0.85rem; font-weight: 600; color: #b91c1c;">{{ healthError }}</span>
  </div>

  <!-- Stats -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-5">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 flex items-center gap-3">
      <div style="width: 44px; height: 44px; border-radius: 10px; background: linear-gradient(135deg, #22c55e, #16a34a); display: flex; align-items: center; justify-content: center; color: white;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px;">arrow_downward</mat-icon>
      </div>
      <div>
        <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Payins hoy</span>
        <div *ngIf="!statsLoading" style="font-size: 1.5rem; font-weight: 800; color: #111827;">{{ stats?.todayPayins || 0 }}</div>
        <div *ngIf="!statsLoading" style="font-size: 0.78rem; color: #16a34a; font-weight: 600;">{{ (stats?.todayPayinAmount || 0) | number:'1.2-2' }} VES</div>
        <mat-spinner *ngIf="statsLoading" diameter="20"></mat-spinner>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 flex items-center gap-3">
      <div style="width: 44px; height: 44px; border-radius: 10px; background: linear-gradient(135deg, #ef4444, #dc2626); display: flex; align-items: center; justify-content: center; color: white;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px;">arrow_upward</mat-icon>
      </div>
      <div>
        <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Payouts hoy</span>
        <div *ngIf="!statsLoading" style="font-size: 1.5rem; font-weight: 800; color: #111827;">{{ stats?.todayPayouts || 0 }}</div>
        <div *ngIf="!statsLoading" style="font-size: 0.78rem; color: #dc2626; font-weight: 600;">{{ (stats?.todayPayoutAmount || 0) | number:'1.2-2' }} VES</div>
        <mat-spinner *ngIf="statsLoading" diameter="20"></mat-spinner>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 flex items-center gap-3">
      <div style="width: 44px; height: 44px; border-radius: 10px; background: linear-gradient(135deg, #fb923c, #c2410c); display: flex; align-items: center; justify-content: center; color: white;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px;">receipt</mat-icon>
      </div>
      <div>
        <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Cargos hoy</span>
        <div *ngIf="!statsLoading" style="font-size: 1.5rem; font-weight: 800; color: #111827;">{{ stats?.todayCargos || 0 }}</div>
        <div *ngIf="!statsLoading" style="font-size: 0.78rem; color: #c2410c; font-weight: 600;">{{ (stats?.todayCargoAmount || 0) | number:'1.2-2' }} VES</div>
        <mat-spinner *ngIf="statsLoading" diameter="20"></mat-spinner>
      </div>
    </div>
    <!-- Reintegros: el banco devolviendo un payout que no se completo.
         Son creditos, pero no son pagos de clientes: por eso van aparte y no
         sumados a los payins. -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 flex items-center gap-3">
      <div style="width: 44px; height: 44px; border-radius: 10px; background: linear-gradient(135deg, #2dd4bf, #0d9488); display: flex; align-items: center; justify-content: center; color: white;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px;">undo</mat-icon>
      </div>
      <div>
        <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Reintegros hoy</span>
        <div *ngIf="!statsLoading" style="font-size: 1.5rem; font-weight: 800; color: #111827;">{{ stats?.todayReintegros || 0 }}</div>
        <div *ngIf="!statsLoading" style="font-size: 0.78rem; color: #0d9488; font-weight: 600;">{{ (stats?.todayReintegroAmount || 0) | number:'1.2-2' }} VES</div>
        <mat-spinner *ngIf="statsLoading" diameter="20"></mat-spinner>
      </div>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 flex items-center gap-3">
      <div style="width: 44px; height: 44px; border-radius: 10px; background: linear-gradient(135deg, #6366f1, #4f46e5); display: flex; align-items: center; justify-content: center; color: white;">
        <mat-icon style="font-size: 22px; width: 22px; height: 22px;">swap_vert</mat-icon>
      </div>
      <div>
        <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Total registrados</span>
        <div *ngIf="!statsLoading" style="font-size: 1.5rem; font-weight: 800; color: #111827;">{{ (stats?.totalPayins || 0) + (stats?.totalPayouts || 0) + (stats?.totalCargos || 0) + (stats?.totalReintegros || 0) }}</div>
        <div *ngIf="!statsLoading" style="font-size: 0.78rem; color: #6b7280; font-weight: 600;">{{ stats?.totalPayins || 0 }} in / {{ stats?.totalPayouts || 0 }} out / {{ stats?.totalCargos || 0 }} cargos / {{ stats?.totalReintegros || 0 }} reint.</div>
        <mat-spinner *ngIf="statsLoading" diameter="20"></mat-spinner>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="bg-white p-4 sm:p-6 rounded-xl shadow-md border border-gray-100 mb-5">
    <div class="flex items-center gap-2 mb-3">
      <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">filter_list</mat-icon>
      <span style="font-size: 0.85rem; font-weight: 700; color: #374151;">Filtros</span>
    </div>
    <div class="flex flex-wrap gap-3">
      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Tipo</mat-label>
        <mat-select [(value)]="filterType" (selectionChange)="applyFilters()">
          <mat-option value="">Todos</mat-option>
          <mat-option value="payin">Payin</mat-option>
          <mat-option value="payout">Payout</mat-option>
          <mat-option value="cargo">Cargo bancario</mat-option>
          <!-- El backend ya clasifica reintegros; sin esta opción no había
               forma de aislarlos en la lista. -->
          <mat-option value="reintegro">Reintegro</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Referencia</mat-label>
        <input matInput [(ngModel)]="filterReference" (keyup.enter)="applyFilters()" placeholder="Ej: 875597">
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Concepto</mat-label>
        <input matInput [(ngModel)]="filterConcept" (keyup.enter)="applyFilters()" placeholder="Ej: C2P">
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Desde</mat-label>
        <input matInput type="date" [(ngModel)]="filterDateFrom" (change)="applyFilters()">
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Hasta</mat-label>
        <input matInput type="date" [(ngModel)]="filterDateTo" (change)="applyFilters()">
      </mat-form-field>
    </div>

    <div class="flex flex-wrap gap-2 mt-3">
      <button type="button" (click)="applyFilters()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
        Buscar
      </button>
      <button type="button" (click)="clearFilters()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
        Limpiar
      </button>
      <button type="button" (click)="exportarXls()" [disabled]="exportingXls"
        [style.opacity]="exportingXls ? '0.5' : '1'" [style.cursor]="exportingXls ? 'not-allowed' : 'pointer'"
        matTooltip="Descarga los movimientos que cumplen los filtros actuales como Excel. Solo operadores." matTooltipTouchGestures="off"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #ecfeff; color: #155e75; border: 1px solid #a5f3fc; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#cffafe'" onmouseout="this.style.background='#ecfeff'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;" [class.spin]="exportingXls">
          {{ exportingXls ? 'sync' : 'download' }}
        </mat-icon>
        Exportar XLS
      </button>
      <button type="button" (click)="forceSync()" [disabled]="syncing"
        [style.opacity]="syncing ? '0.5' : '1'"
        [style.cursor]="syncing ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #f0fdf4; color: #1C593D; border: 1px solid #bbf7d0; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;" [class.spin]="syncing">sync</mat-icon>
        Sync
      </button>
    </div>
  </div>

  <!-- Movimientos -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 20px; border-bottom: 2px solid #bbf7d0;" class="flex items-center justify-between">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">receipt_long</mat-icon>
        <span style="font-size: 1rem; font-weight: 700; color: #1e5a3f;">Movimientos</span>
      </div>
      <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
        {{ movementsTotal }} registros
      </span>
    </div>

    <div *ngIf="movementsLoading" class="flex justify-center py-10">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <div *ngIf="!movementsLoading && movements.length === 0" class="flex flex-col items-center justify-center py-10 text-gray-400">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 8px;">inbox</mat-icon>
      <p style="font-size: 0.85rem; margin: 0;">No se encontraron movimientos</p>
    </div>

    <div *ngIf="!movementsLoading && movements.length > 0">
      <!-- El atributo del tooltip para touch es `matTooltipTouchGestures`, no
           `touchGestures`: escrito mal no entra al input, queda en 'auto' y
           Material le pone `touch-action: none` a cada fila en celular y
           tablet. Como las filas cubren toda la lista, el dedo no podia
           desplazarla. Pasaba solo en N58 porque las filas de Banco Plaza no
           llevan tooltip. -->
      <div *ngFor="let m of movements" class="movement-row" [ngClass]="getMovementClass(m)"
        (click)="openMovementDetail(m)" style="cursor: pointer;"
        matTooltip="Click para ver detalle" matTooltipTouchGestures="off">
        <div class="movement-icon-wrap">
          <mat-icon>{{ getMovementIcon(m) }}</mat-icon>
        </div>
        <div class="flex-1 min-w-0">
          <div style="font-size: 0.82rem; font-weight: 600; color: #111827; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ m.transactionName || 'Sin nombre' }}</div>
          <div class="flex items-center gap-2 mt-0.5 flex-wrap">
            <span class="px-2 py-0.5 text-xs font-bold rounded-full" [ngClass]="getMovementClass(m) + '-badge'">{{ getMovementBadge(m) }}</span>
            <!-- Estado del payout. La fila mostraba tipo y conciliación pero
                 nunca si el pago había salido: eso vive en el log, no en el
                 movimiento. -->
            <span *ngIf="getPayoutStatusLabel(m)" class="px-2 py-0.5 text-xs font-bold rounded-full"
              [ngClass]="getPayoutStatusClass(m)">
              {{ getPayoutStatusLabel(m) }}
            </span>
            <span class="hidden sm:inline" style="font-size: 0.72rem; color: #9ca3af;">{{ m.accountNumber }}</span>
            <!-- Contraparte: en un payin es quién pagó, en un payout a quién
                 le pagamos. El backend la arma en el propio listado. -->
            <span *ngIf="getContraparteFila(m)" style="font-size: 0.72rem; color: #4b5563; font-weight: 600; max-width: 220px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ m.movementType === 'payin' ? 'de' : 'a' }} {{ getContraparteFila(m) }}
            </span>
            <span *ngIf="m.contraparteBanco" style="font-size: 0.7rem; color: #4f46e5; background: #eef2ff; padding: 2px 6px; border-radius: 4px;">
              banco {{ m.contraparteBanco }}
            </span>
          </div>
          <div *ngIf="m.referenceNumber" style="margin-top: 4px; padding: 4px 10px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; display: inline-flex; align-items: center; gap: 4px;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #d97706;">tag</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 700; color: #92400e; font-family: monospace;">{{ m.referenceNumber }}</span>
          </div>
          <div *ngIf="m.movementType === 'payin'" style="margin-top: 4px; padding: 4px 10px; border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; flex-wrap: wrap;"
            [style.background]="m.isInternalCredit ? '#eff6ff' : (m.conciliationStatus === 'RECONCILED' ? '#f0fdf4' : '#f3f4f6')"
            [style.border]="m.isInternalCredit ? '1px solid #bfdbfe' : (m.conciliationStatus === 'RECONCILED' ? '1px solid #bbf7d0' : '1px solid #e5e7eb')">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;"
              [style.color]="m.isInternalCredit ? '#1d4ed8' : (m.conciliationStatus === 'RECONCILED' ? '#15803d' : '#9ca3af')">
              {{ m.isInternalCredit ? 'admin_panel_settings' : (m.conciliationStatus === 'RECONCILED' ? 'check_circle' : 'schedule') }}
            </mat-icon>
            <span style="font-size: 0.78rem; font-weight: 700;"
              [style.color]="m.isInternalCredit ? '#1d4ed8' : (m.conciliationStatus === 'RECONCILED' ? '#15803d' : '#6b7280')">
              {{ m.isInternalCredit ? 'Acreditado interno N58' : (m.conciliationStatus === 'RECONCILED' ? 'Acreditado' : 'Pendiente') }}
            </span>
            <span *ngIf="m.isInternalCredit && m.referenciaOperatorEmail"
              style="font-size: 0.7rem; color: #1d4ed8; font-family: monospace;">
              · {{ m.referenciaOperatorEmail }}
            </span>
            <span *ngIf="!m.isInternalCredit && m.conciliationStatus === 'RECONCILED' && m.userId"
              style="font-size: 0.75rem; font-weight: 700; color: #15803d; font-family: monospace;">
              · ID: {{ m.userId }}
            </span>
          </div>
          <div style="font-size: 0.72rem; color: #6b7280; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ m.transactionConcept || '' }}</div>
          <!-- Documento del beneficiario y usuario: no existen en el feed del
               banco, los cruza el backend contra `n58_transaction_logs` y la
               transacción. Espejo de los chips `ben:` / `user:` de BP. -->
          <div *ngIf="m.beneficiarioDocumento || m.usuarioIdPayout || m.contraparteCuenta"
            class="flex flex-wrap gap-2 mt-1">
            <span *ngIf="m.beneficiarioDocumento" style="font-size: 0.7rem; color: #6b7280; font-family: monospace;">
              ben: {{ m.beneficiarioDocumento }}
            </span>
            <span *ngIf="m.contraparteCuenta" style="font-size: 0.7rem; color: #6b7280; font-family: monospace;">
              cta: {{ m.contraparteCuenta }}
            </span>
            <span *ngIf="m.usuarioIdPayout" style="font-size: 0.7rem; color: #15803d; font-family: monospace;">
              user: {{ m.usuarioIdPayout }}
            </span>
          </div>
        </div>
        <div class="text-right flex-shrink-0">
          <div style="font-size: 0.88rem; font-weight: 700;" [ngClass]="getMovementClass(m) + '-text'">
            {{ getAmountSign(m) }}{{ m.amount | number:'1.2-2' }} {{ m.currency || 'Bs' }}
          </div>
          <div style="font-size: 0.7rem; color: #9ca3af; margin-top: 2px;">{{ m.transactionDate | date:'dd/MM/yyyy HH:mm':'America/Caracas' }} <span style="font-size: 0.6rem; color: #cbd5e1;">VE</span></div>
        </div>
      </div>
    </div>

    <!-- Paginacion -->
    <div *ngIf="movementsPages > 1" class="flex items-center justify-center gap-4 py-3 border-t border-gray-100">
      <button type="button" [disabled]="movementsPage <= 1" (click)="goPage(movementsPage - 1)"
        [style.opacity]="movementsPage <= 1 ? '0.4' : '1'"
        [style.cursor]="movementsPage <= 1 ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.78rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">chevron_left</mat-icon>
        Anterior
      </button>
      <span style="font-size: 0.78rem; color: #9ca3af; font-weight: 500;">Página {{ movementsPage }} de {{ movementsPages }}</span>
      <button type="button" [disabled]="movementsPage >= movementsPages" (click)="goPage(movementsPage + 1)"
        [style.opacity]="movementsPage >= movementsPages ? '0.4' : '1'"
        [style.cursor]="movementsPage >= movementsPages ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.78rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        Siguiente
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">chevron_right</mat-icon>
      </button>
    </div>
  </div>

</div>
